<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.users.roles.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :paginate="false"
                        :exportable = "false" title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @rowClickEdit="onEditRow"
                        @rowClickDelete="onDeleteRow"
                        @rowClickCheck="onClickCheck"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                    >
                    </data-table>

                    <b-btn class="btn btn-dark mt-3" @click="returnToUsers">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_users')}}
                    </b-btn>

                    <b-btn class="btn btn-default ml-1 mt-3" @click="onAddRow" v-if="this.$store.getters.hasPermission(['users', 'platform'], ['update'])">
                        <i class="fa fa-plus-circle mr-1"></i> {{$t('general.users.roles.add_role')}}
                    </b-btn>
                </b-card>
            </div>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="this.$store.state.ajax_in_progress">
            <div class="row">
                <div class="col-sm-12">
                    <div class="row mb-3" style="z-index:100;position:relative;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.role') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedRole"
                                :options="currentRoles"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isRoleLoading"
                                :preserve-search="true" 
                                placeholder="" 
                                label="name2" track-by="id" 
                                :selectLabel="''"
                                @search-change="onRoleSearch" 
                                @input="updateRole"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedRole != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedRole"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                    <div class="row mb-3" style="position:relative;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.employee_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="15" class="form-control" name="employee_no" placeholder="" v-model="model.employee_no">
                        </div>
                    </div>

                    <div class="row mb-3" style="position:relative;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.is_welder') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.is_welder" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" style="position:relative;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.welder_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" name="welder_no" placeholder="" v-model="model.welder_no">
                        </div>
                    </div>

                    <div class="row mb-3" style="position:relative;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.welder_status') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.welder_status">
                                <option v-for="status in statuses" :value="status.name">{{status.name}}</option>
                            </select>
                        </div>
                    </div>

                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import VueLodash from 'vue-lodash'
Vue.use(VueLodash);
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';
import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

export default {
    name: 'roles',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons,
        flatPickr,
        Multiselect,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.users.title'),
                    to: '/users/'
                },
                {
                    text: Vue.i18n.translate('general.users.roles.roles_for'),
                    active: true
                }
            ],
            tableName: 'user_roles',
            tableNameTranslated: Vue.i18n.translate('general.users.roles.title_modal'),
            row: null,
            buttonYes: true,
            buttonNo: false,
            toggleLabels: false,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            currentPage: 1,
            pageCount: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',

            selectedRole: null,
            currentRoles: [],
            isRoleLoading: false,

            getData: {
                rowData: [],
            },

            model: {
                role_id: null,
                employee_no: null,
                is_welder: null,
                welder_no: null,
                welder_status: null,
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '90px',
                    field: '',
                    showDeleteButton: true,
                    showEditButton: true,
                },
                {
                    label: Vue.i18n.translate('table.user_roles.role'),
                    field: 'name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.user_roles.company'),
                    field: 'company_name',
                    numeric: false,
                    html: false
                },
                {
                    label: Vue.i18n.translate('table.user_roles.employee_no'),
                    field: 'employee_no',
                    numeric: false,
                    html: false
                },
                {
                    label: Vue.i18n.translate('table.user_roles.is_welder'),
                    field: 'is_welder',
                    showAsCheck: true,
                    numeric: false,
                    html: false
                },
            ]
        }
    },
    computed: {
        statuses: {
            get: function () {
                let statuses = this.$store.getters.getWelderStatuses;
                return statuses;
            }
        }
    },
    watch: {
        statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    mounted () {
        this.onLoadTable();
        this.buttonYes = Vue.i18n.translate('misc.yes');
        this.buttonNo = Vue.i18n.translate('misc.no');
        this.toggleLabels = {checked: this.buttonYes, unchecked: this.buttonNo};
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        onClickCheck (row, index, column) {
            if (row) {
                this.model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                var clone = Object.assign({}, row);
                clone['is_welder'] = !clone.is_welder;

                http.route('user/' + this.$route.params.id + '/roles').post(clone, true).then(response => {
                    if (response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        row['is_welder'] = !row.is_welder;

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
                this.model[column.toString()] = null;
            }
        },
        returnToUsers () {
            this.$router.push({name: 'users'});
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page
            this.onLoadTable()
        },
        onLoadTable () {
            let data = http.route('user/'+this.$route.params.id+'/roles' + '?get_all=1&filters[user_id]=1&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (response.data != false) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;

                    this.breadcrumbItems[2].text = Vue.i18n.translate('general.users.roles.roles_for') + ': "' + (response.other.email ? response.other.email :  response.other.id_no)+'"';

                    this.setRowData(response.data);
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }

                this.tableLoaded = true;
            });
        },
        setRowData(response) {
            let data = [];
            response.forEach(function(value, key) {
                if (value.company) {
                    value.company_name = value.company.name
                }
                data[key] = value;
            });

            this.getData.rowData = data;
        },
        onClick () {
            this.$refs.revisionModal.show()
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.model.role_id = null;
            this.model.employee_no = null;
            this.model.is_welder = null;
            this.model.welder_no = null;
            this.model.welder_status = null;
            this.selectedRole = null;

            this.$refs.saveModal.show()
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row,

            this.model.is_welder = Boolean(this.row.is_welder);
            this.model.welder_no = this.row.welder_no;
            this.model.welder_status = this.row.welder_status;
            this.model.employee_no = this.row.employee_no;

            if (this.row.role_id) {
                this.selectedRole = [{name2: this.row.name, id: this.row.role_id}];
            } else {
                this.selectedRole = null;
            }
            this.model.role_id = this.row.role_id;

            this.$refs.saveModal.show()
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row
            this.$refs.deleteModal.show()
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                //user_id: this.$route.params.id,
                role_id: this.model.role_id,
                employee_no: this.model.employee_no,
                is_welder: this.model.is_welder,
                welder_no: this.model.welder_no,
                welder_status: this.model.welder_status,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });
            
            let data = http.route('user/'+this.$route.params.id+'/roles').post(put_data, true);
            data.then(response => {
                if(response.data == false) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    this.$refs.saveModal.hide();
                }
            });
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route('user/'+this.$route.params.id+'/roles/' + this.row.id).delete();
                data.then(response => {
                    if (response.isError == false) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        this.$refs.deleteModal.hide();
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
        },
        onRoleSearch(search) {
            if (search == '') {
                this.currentRoles = [];
                
                return false;
            }

            this.isRoleLoading = true;
            this.searchRole(search, this);
        },
        searchRole: _.debounce((search, vm) => {
            let data = http.route('user/'+vm.$route.params.id+'/roles?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentRoles = response.data;
                }
                vm.isRoleLoading = false;
            });
        }, 500),
        updateRole(role) {
            this.model.role_id = (role != null) ? role.id : null;
        },
        clearSelectedRole () {
            this.selectedRole  = null;
            this.model.role_id = null;
        },
        slugify(text) {
            let str = text.target.value;
            this.model.type = str.toString()
                .toLowerCase()
                .trim()
                .replace(/&/g, '-and-') //
                .replace(/[\s\W-]+/g, '-')
                .replace(/--+/g, '-')
                .replace(/^-+|-+$/g, '');
        }
    }
}

</script>

<style scoped>
	select {
		-webkit-appearance:menulist-button;
		-moz-appearance:menulist-button;
	}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/pages/users/user_roles.vue